import React from "react";
import Main from "./main/Main";
import { SnaWAConfig, subConfig } from "./SnaWAConfig";

export const getMainContent = (contentName, subPageName) => {
  const find = SnaWAConfig.content.find((item) => item.name === contentName);

  if (find.subPage) {
    const findSub = subConfig[find?.name].content.find(
      (item) => item.name === subPageName
    );
    const { component: Component } = findSub;
    return <Component />;
  }
  if (find) {
    return <Main />;
  }
  return null;
};
